import { Navigate } from "react-router-dom";
import { getAdminAuth } from "./store/menupro.admin.store";

export const AdminProtectedRoute = ({ children }) => {
  const a = getAdminAuth();
  return a?.u && a?.p ? children : <Navigate to="/menupro/admin-login" />;
};
